import { ApiReference } from '@/containers/guides';
import { useGo } from '@/lib/useGo';

export default function ReferenceRoute() {
  const go = useGo();
  return <ApiReference go={go} />;
}
